export const sourceConstant = {
    subtitle:{en:"The answer is sourced from:",
              hi:"जवाब यहाँ से प्राप्त किया गया है:",
              or: "ଉତ୍ତରଟି ଏହିଠାରୁ ନିଆଯାଇଛି:"},
    page: {
        en: "Page",
        hi: "पेज",
        or: "ପୃଷ୍ଠା",
    },
    and: {
        en: "and",
        hi: "और",
        or: "ଏବଂ",
    }
}
export const pdfViewerConstant = {
    backToChat: {
        en: "Back to Chat",
        hi: "चैट पर वापस जाएं",
        or: "ଚାଟ ପରେ ଫେରାଇବା",
    },
    enterPageNumber: {
        en: "Enter page number",
        hi: "पेज नंबर डालें",
        or: "ପେଜ୍ ନମ୍ବର ଦିଅନ୍ତୁ"
      },
      go: {
        en: "Go",
        hi: "जाएँ",
        or: "ଯାଆନ୍ତୁ"
      },
      cancel: {
        en: "Cancel",
        hi: "कैंसिल",
        or: "କ୍ୟାନସେଲ୍"
      },
      enterValidPageNumber: {
        en: "Enter Valid page number only",
        hi: "सही पेज नंबर डालें",
        or: "ସଠିକ୍ ପେଜ୍ ନମ୍ବର ଦିଅନ୍ତୁ"
      }
      
}